<template>
<DIV>
  <ItpBox direction=row align-items="top">
  <div class=mr-2>
    <UcInvoiceTypeBadge :value="option.invoice_type" :kind="option.invoice_kind" :advance="option.is_advance" abbreviated></UcInvoiceTypeBadge>
  </div>

  <div>
    <strong>{{ option.entry_number }}</strong>
    <strong v-if="option.invoice">&middot;&nbsp;{{ option.invoice.invoice_number }}</strong>
    <span v-if="option.partner">&middot;&nbsp;{{ option.partner.name }}</span>
    <span>
    </br>{{ option.subject }}
    </span>
    </br>
    {{ option.entry_date | date }}
    <!--span>&middot;&nbsp;{{ option.amount.amount | number }} {{ option.amount.currency}}</span-->
  </div>
</ItpBox>

</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcSuggestRegisterEntryOption extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: Object,
  })
  option!: object;

  @Watch('option')
  onOption(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("option")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcSuggestRegisterEntryOption", UcSuggestRegisterEntryOption);

</script>